import {GameFlowController} from '../../components/game-flow-controller.js';
import {MenuPanels} from '../../models/UIModel.js';

/**
 * Sends a message to the GameFlowController to go to the previous menu.
 * @param parentMenu The menu that this function is on.
 */
export function goToPreviousMenu(parentMenu: MenuPanels) {
    const gameFlow = GameFlowController.instance;
    if (gameFlow.canChangeMenu && gameFlow.isMenuCurrentTop(parentMenu)) {
        gameFlow.popMenu(null);
    }

    //TK Note: The original game also had an implementation for when the back key was pressed
    //on Android. I'm not sure if this is necessary for the web version. While technically we
    //could implement the browser back button, but this would be more complicated then just
    //catching a button.
}
